import { Component, input, output } from '@angular/core';

import { faComment, faEye } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'empathy-notepad-side-tabs',
  templateUrl: './notepad-side-tabs.component.html',
  styleUrls: ['./notepad-side-tabs.component.scss']
})
export class NotepadSideTabsComponent {
  selectedTab = input(0);
  showComments = input(true);

  selectedIndexChange = output<number>();

  faComment = faComment;
  faEye = faEye;
}
